import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Tooltip } from "@mui/material";
import Navbar from '../../../AdminDashboard/AdminHeader/AdminHeader';
import SideBar from '../../../AdminDashboard/AdminSidebar/AdminSidebar';
import { API_LoginURL } from '../../../../../config';

import totalStudents from './totalStudents.png';
import activeStudents from './activeStudents.png';
import inactiveStudents from './inactiveStudents.png';
import grade6 from './grade6.png';
import grade7 from './grade7.png';
import grade8 from './grade8.png';
import grade9 from './grade9.png';
import grade10 from './grade10.png';

import './AdminHome.css';

const Dashboard = () => {
  const [totalStudents1, setTotalStudents] = useState(0);
  const [activeStudents1, setActiveStudents] = useState(0);
  const [inactiveStudents1, setInactiveStudents] = useState(0);
  const [studentsPerClass, setStudentsPerClass] = useState({});

  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${API_LoginURL}user/UserList`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Fetch Users Error:", error);
      return [];
    }
  };

  useEffect(() => {
    const getUserStats = async () => {
      try {
        const response = await fetchUsers();
        const users = Array.isArray(response) ? response : [];

        const total = users.length;
        const active = users.filter((u) => u.isActive === true).length;
        const inactive = users.filter((u) => u.isActive === false).length;

        const classCounts = users.reduce((acc, user) => {
          if (user.className) {
            acc[user.className] = acc[user.className] || { count: 0, students: [] };
            acc[user.className].count += 1;
            acc[user.className].students.push(`${user.firstName} ${user.lastName}`);
          }
          return acc;
        }, {});

        setTotalStudents(total);
        setActiveStudents(active);
        setInactiveStudents(inactive);
        setStudentsPerClass(classCounts);
      } catch (error) {
        console.error("Failed to fetch user stats:", error);
        setTotalStudents(0);
        setActiveStudents(0);
        setInactiveStudents(0);
        setStudentsPerClass({});
      }
    };

    getUserStats();
  }, []);

  return (
    <div className="container-scroller">
      <Navbar />
      <div className="container-fluid page-body-wrapper">
        <SideBar />
        <div className="main-panel">
          <div className="card">
            <div className="card-body">
              <div className='adminHomeMain'>
                <div className='adminHomeUpper'>
                  <div className='adminHomeCard'>
                    <div className='adminHomeCardLeft'>
                      <p>Total Students</p>
                      <h1>{totalStudents1}</h1>
                    </div>
                    <div className='adminHomeCardRight'>
                      <img src={totalStudents} alt="Total Students" />
                    </div>
                  </div>
                  <div className='adminHomeCard'>
                    <div className='adminHomeCardLeft'>
                      <p>Active Students</p>
                      <h1>{activeStudents1}</h1>
                    </div>
                    <div className='adminHomeCardRight'>
                      <img src={activeStudents} alt="Active Students" />
                    </div>
                  </div>
                  <div className='adminHomeCard'>
                    <div className='adminHomeCardLeft'>
                      <p>Inactive Students</p>
                      <h1>{inactiveStudents1}</h1>
                    </div>
                    <div className='adminHomeCardRight'>
                      <img src={inactiveStudents} alt="Inactive Students" />
                    </div>
                  </div>
                </div>

                <div className='adminHomeLower'>
                  <div className='adminHomeLowerInner'>
                    {Object.entries(studentsPerClass).map(([className, data]) => (
                      <Tooltip key={className} title={data.students.join(", ")} arrow>
                        <div className='adminHomeCard lower'>
                          <div className='adminHomeCardLeft'>
                            <p>Class- {className}</p>
                            <h1>{data.count}</h1>
                          </div>
                          <div className='adminHomeCardRight'>
                            <img
                              src={
                                className.includes("6") ? grade6 :
                                className.includes("7") ? grade7 :
                                className.includes("8") ? grade8 :
                                className.includes("9") ? grade9 :
                                grade10
                              }
                              alt={className}
                            />
                          </div>
                        </div>
                      </Tooltip>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> {/* page-body-wrapper */}
    </div>     // container-scroller
  );
};

export default Dashboard;
